import useFetch from './useFetch.ts';
import { useCallback } from 'react';
export const useLoginRequest = function () {
    const fetcher = useFetch();
    return useCallback(function (email, code) {
        return fetcher(`/api/user/login`, {
            method: 'POST',
            body: JSON.stringify({
                email,
                code,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }, [fetcher]);
};
